import Swiper, { Navigation, Autoplay, EffectFade, EffectCoverflow, EffectFlip, EffectCube, EffectCreative, Parallax } from 'swiper'

document.addEventListener('app:load', init)

function init ()
{
	if (!document.querySelector('#header'))
	{
		return
	}
	
	const slider = document.querySelector('#header .slider')
	const sliderAxis = slider.dataset.axis
	const sliderEffect = slider.dataset.effect
	
	let direction = 'vertical', effect = 'slide', speed = 1500, fadeEffect = false, coverflowEffect = false, flipEffect = false, cubeEffect = false, creativeEffect = false
	
	if (sliderAxis === 'horizontal')
	{
		direction = 'horizontal'
		speed = 2000
	}
	else if (sliderAxis === 'vertical')
	{
		direction = 'vertical'
		speed = 1500
	}
	
	if (innerWidth < 750)
	{
		effect = 'slide'
		direction = 'vertical'
		speed = 1500
	}
	else if (sliderEffect === 'slide')
	{
		effect = 'slide'
	}
	else if (sliderEffect === 'fade')
	{
		effect = 'fade'
		fadeEffect = {
			crossFade: true
		}
	}
	else if (sliderEffect === 'coverflow')
	{
		effect = 'coverflow'
		coverflowEffect = {
			rotate: 30,
			slideShadows: false
		}
	}
	else if (sliderEffect === 'flip')
	{
		effect = 'flip'
		flipEffect = {
			rotate: 30,
			slideShadows: false
		}
	}
	else if (sliderEffect === 'cube')
	{
		effect = 'cube'
		cubeEffect = {
			rotate: 30,
			slideShadows: false,
			shadow: false
		}
	}
	else if (sliderEffect === 'slide_fade')
	{
		effect = 'creative'
		creativeEffect = {
			prev: {
				translate: direction === 'vertical' ? [0, -100, 0] : [-100, 0, 0],
				opacity: 0
			},
			next: {
				translate: direction === 'vertical' ? [0, 100, 0] : [100, 0, 0],
				opacity: 0
			}
		}
	}
	else if (sliderEffect === 'slide_scale')
	{
		effect = 'creative'
		creativeEffect = {
			prev: {
				translate: [0, 0, -400]
			},
			next: {
				translate: direction === 'vertical' ? [0, '100%', 0] : ['100%', 0, 0]
			}
		}
	}
	
	const swiperInstance = new Swiper(slider.querySelector('.swiper'), {
		modules: [Autoplay, Navigation, EffectFade, EffectCoverflow, EffectFlip, EffectCube, EffectCreative, Parallax],
		slidesPerView: 1,
		effect: effect,
		direction: direction,
		speed: speed,
		fadeEffect: fadeEffect,
		coverflowEffect: coverflowEffect,
		flipEffect: flipEffect,
		cubeEffect: cubeEffect,
		creativeEffect: creativeEffect,
		parallax: {
			enabled: true
		},
		autoplay: false,
		spaceBetween: 0,
		loop: true,
		// loopPreventsSlide: false,
		navigation: {
			prevEl: slider.querySelector('.swiper-button-prev'),
			nextEl: slider.querySelector('.swiper-button-next')
			
		}
		/*breakpoints: {
		 1160: {
		 allowTouchMove: false
		 }
		 }*/
	})
	
	const header = document.querySelector('#header')
	const firstSlide = slider.querySelector('.swiper-slide-active')
	let firstSlideImg
	
	if (innerWidth > 750)
	{
		firstSlideImg = firstSlide.querySelector('figure img')
	}
	else
	{
		firstSlideImg = firstSlide.classList.contains('has-mobile-img') ? firstSlide.querySelector('figure.mobile-img img') : firstSlide.querySelector('figure img')
	}
	
	firstSlideImg.addEventListener('load', () =>
	{
		header.classList.add('loading')
		
		swiperInstance.params.autoplay = {
			delay: 4000,
			disableOnInteraction: true
		}
		
		swiperInstance.autoplay.start()
		
		setTimeout(() =>
		{
			header.classList.add('loaded')
		}, 1000)
	})
	
	/*const header = document.querySelector('#header')
	 const firstSlideImg = slider.querySelector('.swiper-slide img')
	 
	 document.addEventListener('lazyloaded', (e) =>
	 {
	 if (e.path[0] === firstSlideImg)
	 {
	 header.classList.add('loading')
	 
	 swiperInstance.params.autoplay = {
	 delay: 4000,
	 disableOnInteraction: true
	 }
	 
	 swiperInstance.autoplay.start()
	 
	 setTimeout(() =>
	 {
	 header.classList.add('loaded')
	 }, 1000)
	 }
	 })*/
}
